import { useRef, useEffect } from 'react'
/**
 * CursorGlow — a soft radial glow that follows the mouse cursor,
 * adding depth to the dark background without extra GPU cost.
 */
export function CursorGlow() {
  const ref = useRef()
  useEffect(() => {
    const fn = e => {
      if (ref.current) {
        ref.current.style.left = `${e.clientX}px`
        ref.current.style.top  = `${e.clientY}px`
      }
    }
    window.addEventListener('mousemove', fn)
    return () => window.removeEventListener('mousemove', fn)
  }, [])
  return <div ref={ref} id="cg" />
}
